import React, { useState } from 'react';
import InteractiveFloorPlan from '../../components/InteractiveFloorPlan/InteractiveFloorPlan';
import { floorPlans } from '../../data/floorPlanData.js';
import floorPlanStyles from './FloorPlansContent.module.css';
import styles from './OutdoorAreasContent.module.css';

const OutdoorAreasContent = () => {
  const [activeArea, setActiveArea] = useState({
    title: 'Outdoor Areas & Grounds',
    info: 'Click any highlighted area on the interactive map to view more details.',
  });

  const levelData = floorPlans.outdoor;

  const handleAreaSelect = (area) => {
    setActiveArea(area);
  };

  const handleResetView = () => {
    // CORRECTED: Also ensure this reset handler uses the correct format.
    setActiveArea({
      title: 'Outdoor Areas & Grounds',
      info: 'Click any highlighted area on the interactive map to view more details.',
    });
  };

  return (
    <section className={floorPlanStyles.mainContainer}>
      <div className={styles.outdoorWrapper}>
        <div className={styles.mapColumn}>
          <div className={floorPlanStyles.unifiedMapContainer}>
            <div className={floorPlanStyles.mapContainer}>
              {levelData ? (
                <InteractiveFloorPlan
                  key="outdoor"
                  imageName={levelData.imageName}
                  imageAlt={levelData.imageAlt}
                  mapName={levelData.mapName}
                  areas={levelData.areas}
                  onAreaSelect={handleAreaSelect}
                  onBackgroundClick={handleResetView}
                />
              ) : (
                <p>Map data could not be loaded.</p>
              )}
            </div>
          </div>
        </div>

        <div className={styles.infoColumn}>
          <div className={floorPlanStyles.activeRoomInfo} style={{ flexDirection: 'column' }}>
            <div className={floorPlanStyles.infoText}>
              <h3>{activeArea.title}</h3>
              <p>{activeArea.info}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OutdoorAreasContent;
